import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {
  MatBottomSheet,
  MatBottomSheetRef,
  MAT_BOTTOM_SHEET_DATA,
} from '@angular/material/bottom-sheet';
import { Subscription } from 'rxjs';
import { RecipeIngredientModel } from 'src/app/core/model/object/recipe-model';
import { CookingStoryRecipePageDataService } from 'src/app/data/repository/cooking-story/cooking-story-recipe-page-data.service';
import { CookingStoryBottomSheetChangeUnitComponent } from '../cooking-story-bottom-sheet-change-unit/cooking-story-bottom-sheet-change-unit.component';
import { CookingStoryBottomSheetComponent } from '../cooking-story-bottom-sheet.component';

@Component({
  selector: 'app-cooking-story-bottom-sheet-change-value',
  templateUrl: './cooking-story-bottom-sheet-change-value.component.html',
  styleUrls: ['./cooking-story-bottom-sheet-change-value.component.scss'],
})
export class CookingStoryBottomSheetChangeValueComponent
  implements OnInit, AfterContentChecked, OnDestroy
{
  item: RecipeIngredientModel;
  activeId: string;
  active: boolean = true;
  amount: number;
  name: string;
  unit: { name: string; _id: string } = {
    name: '',
    _id: '',
  };
  subscriptions: Subscription[] = [];
  unitDescription: string;
  description: string;
  listed: boolean = true;
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: { id: string },
    private bottomSheetRef: MatBottomSheetRef<CookingStoryBottomSheetChangeValueComponent>,
    private RecipePageDataService: CookingStoryRecipePageDataService,
    private matBottomSheet: MatBottomSheet,
    private cdRef: ChangeDetectorRef
  ) {}
  ngOnInit(): void {
    this.activeId = this.RecipePageDataService.getActiveItemId();
    this.item = this.RecipePageDataService.getItem(this.activeId);
    if (!this.item) {
      this.item = this.RecipePageDataService.getBackUpItem(this.activeId);
      this.listed = false;
    }
    this.replaceData();
    this.checkValid();
  }
  backToList() {
    const bottomSheetRef = this.matBottomSheet.open(
      CookingStoryBottomSheetComponent,
      {
        panelClass: 'custom-bottomsheet-container',
      }
    );
  }
  ngAfterContentChecked() {
    this.cdRef.detectChanges();
  }
  checkValid() {
    // if (typeof amount == 'number') {
    //   this.active = true;
    // } else {
    //   this.active = false;
    // }
  }
  openChangeUnit() {
    const bottomSheetRef = this.matBottomSheet.open(
      CookingStoryBottomSheetChangeUnitComponent,
      {
        panelClass: 'custom-bottomsheet-container',
        data: {
          id: this.activeId,
        },
      }
    );

    const sb = bottomSheetRef.backdropClick().subscribe((x) => {
      this.reopen();
    });
    this.subscriptions.push(sb);
  }
  reopen() {
    const bottomSheetRef = this.matBottomSheet.open(
      CookingStoryBottomSheetChangeValueComponent,
      {
        panelClass: 'custom-bottomsheet-container',
        data: {
          id: this.activeId,
        },
      }
    );
    const sb = bottomSheetRef.backdropClick().subscribe((data) => {
      this.backToList();
    });
    this.subscriptions.push(sb);
  }
  replaceData() {
    this.name = this.item.food.name;
    this.amount = this.item.amount;
    this.unitDescription = this.item.unitDescription;
    this.description = this.item.description;
  }
  submit() {
    if (this.active) {
      if (this.listed) {
        const data = new RecipeIngredientModel(
          this.amount,
          this.item.cooked,
          this.item.food,
          null,
          this.activeId,
          this.unitDescription,
          this.description,
          this.item.kitchenInventory,
          this.item.unit
        );

        this.RecipePageDataService.updateItem(data);
        this.RecipePageDataService.updateSaveItem(data);

        this.backToList();
      } else {
        const data = new RecipeIngredientModel(
          this.amount,
          this.item.cooked,
          this.item.food,
          null,
          this.activeId,
          this.unitDescription,
          this.description,
          this.item.kitchenInventory,
          this.item.unit
        );
        this.RecipePageDataService.updateSaveItem(data);

        this.backToList();
      }
    }
  }
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }
}
